<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Input
              class="search-ipt"
              type="text"
              v-model="keyword"
              placeholder="请输入方案名称"
              @on-enter="getClassCardList"
              clearable
            />
            <Button
              type="primary"
              icon="md-search"
              class="search_tn"
              data-level="common"
              @click="getClassCardList"
            >搜索</Button>
            <Button class="top_search_btn" @click="oneKeyAddFlagModal" type="primary">一键复测</Button>
            <Button class="top_search_btn" @click="studentModel=true" type="primary">导出表格</Button>
          </div>
        </div>
      </div>
      <Table
        class="main_table"
        size="large"
        stripe
        border
        :columns="tableHeader"
        :row-class-name="rowClass"
        @on-selection-change="handlerChange"
        :data="tableData"
      >
        <template slot-scope="{ row, index}" slot="type">
          <span>{{typeList[row.type - 1]}}</span>
        </template>
        <template slot-scope="{ row, index}" slot="totalScore">
          <span>{{row.totalScore/100}}</span>
        </template>
        <template slot-scope="{ row, index}" slot="gradeName">
          <span>{{row.grade}}{{row.className}}</span>
        </template>
        <template slot-scope="{ row, index}" slot="action">
          <a class="jump_color" @click="addPlanShow(row.id)">复测方案</a>
          <a class="jump_color" @click="toDetails(row,index)">详情</a>
        </template>
      </Table>
    </div>
    <Modal
      v-model="addPlanFlag"
      width="550"
      title="复测方案"
      okText="复测"
      @on-ok="AddPlanConfirm"
      @on-cancel="AddPlanCancel"
    >
      <div class="modal_item_wrapper">
        <span class="modal_label">方案</span>
        <Select v-model="selectedPlanId" class="item_context">
          <Option v-for="item in planList" :value="item.id" :key="item.id">{{item.schemeName}}</Option>
        </Select>
      </div>
    </Modal>
    <Modal v-model="oneKeyAddFlag" width="550" title="复测方案" okText="一键复测" @on-ok="oneKeyPlan">
      <div class="modal_item_wrapper">
        <span class="modal_label">方案</span>
        <Select v-model="onKeySelectedPlanId" class="item_context">
          <Option v-for="item in planList" :value="item.id" :key="item.id">{{item.schemeName}}</Option>
        </Select>
      </div>
    </Modal>
    <Modal v-model="studentModel" title="选中学生" @on-ok="studentModelOK">
      <div class="modal_item_wrapper" style="display:flex;  justify-content: center;">
        <Select v-model="selectStudent" style="width:200px">
          <Option
            v-for="item in students"
            :value="item.studentId"
            :key="item.studentId"
          >{{ item.studentName }}</Option>
        </Select>
      </div>
    </Modal>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getClassCardList"></paging>
  </div>
</template>
<script>
import paging from "../templates/Paging.vue";
import {
  _getClassCardList,
  _getPlanList,
  _againTestPlan,
  _recognitionTestStudents,
  _recognitionExportErrorStatistics
} from "../api/api";
import { alertTips, dealDate } from "../common/common.js";
import global from "../common/Global";

export default {
  name: "OCRCard",
  components: { paging },
  data() {
    return {
      pageSize: 10, // 每页条数
      currentNum: 1, // 当前页码
      totalNum: 0, // 数据总条数
      keyword: "", // 搜索内容
      addPlanFlag: false, //添加方案Modal
      oneKeyAddFlag: false, //添加一键方案Modal
      studentModel: false, //选中学生Modal
      selectedCardId: 0, //选中的id
      selectedIndex: -1, // 选中行的index
      selectedPlanId: 0, // 选中的方案id
      onKeySelectedPlanId: 0, // 选中的方案id
      selectStudent: 0, // 选中的学生
      students: [], 
      typeList: ["答题卡", "教辅", "答题本", "练习册"], //类别列表
      planList: [], // 方案列表
      tableHeader: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "Id",
          key: "id"
        },
        {
          title: "类别",
          key: "type",
          slot: "type"
        },
        {
          title: "名称",
          key: "name"
        },
        {
          title: "总分",
          key: "totalScore",
          slot: "totalScore"
        },
        {
          title: "班级",
          key: "gradeName",
          slot: "gradeName"
        },
        {
          title: "科目",
          key: "subject"
        },
        {
          title: "测试次数",
          key: "testNum"
        },
        {
          title: "更新时间",
          key: "createDate"
        },
        {
          title: "操作",
          slot: "action",
          width: 160
        }
      ],
      tableData: [
        {
          id: 125,
          title: "测试规则1",
          updateTime: "2019-08-29"
        }
      ],
      selectSubjects: []
    };
  },
  methods: {
    //      点击行的颜色
    rowClassName(row, index) {
      //        console.log("index--",index);
      return this.selectedIndex === index ? "selected_row_class" : "";
    },
    //      添加方案Modal显示
    addPlanShow(id) {
      this.selectedCardId = id;
      this.getPlanList();
      this.addPlanFlag = true;
    },
    //      点击行的颜色
    rowClass(row, index) {
      for (let item of this.tableData) {
        if (index == this.selectedIndex) {
          return "selected_row_class";
        }
      }
    },
    getPlanList() {
      const self = this;
      _getPlanList().then(res => {
        if (res.code === 0) {
          self.planList = res.data.content;
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //    添加方案确定即 复测
    AddPlanConfirm() {
      const self = this;
      let dataInfo = {
        id: self.selectedCardId,
        schemeId: self.selectedPlanId
      };
      _againTestPlan(dataInfo).then(res => {
        if (res.code === 0) {
          self.selectedCardId = 0;
          self.selectedPlanId = 0;
          self.planList = [];
          alertTips("success", "复测成功");
          self.getClassCardList();
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //    一键复测
    oneKeyPlan() {
      const self = this;
      let requestArr = [];
      for (let item of this.selectSubjects) {
        let dataInfo = {
          id: item.id,
          schemeId: self.onKeySelectedPlanId
        };
        requestArr.push(_againTestPlan(dataInfo));
      }
      Promise.all(requestArr).then(res => {
        self.planList = [];
        self.getClassCardList();
        alertTips("success", "一键复测成功");
      });
    },
    //    一键复测弹出框
    oneKeyAddFlagModal() {
      this.oneKeyAddFlag = true;
      this.getPlanList();
    },
    //添加方案取消
    AddPlanCancel() {
      this.addPlanFlag = false;
      this.selectedCardId = 0;
      this.selectedPlanId = 0;
      this.planList = [];
    },
    //选中某题
    handlerChange(e) {
      this.selectSubjects = e;
      this.recognitionTestStudents(e[0].id);
    },
    //     查看详情
    toDetails(row, index) {
      this.selectedIndex = index;
      this.$router.push(
        `/OCRCard/${row.id}?sheetId=${row.pagerSheetId}&subject=${row.subject}`
      );
    },
    //      获取答题卡列表
    getClassCardList(msg) {
      const self = this;
      self.selectedIndex = -1;
      self.currentNum =
        typeof msg === "object" && msg.pageNum ? msg.pageNum : self.currentNum;
      let paramsInfo = {
        page: self.currentNum - 1,
        size: self.pageSize,
        sort: "updateTime,desc"
      };
      _getClassCardList(paramsInfo).then(res => {
        if (res.code === 0) {
          res.data.content.forEach(item => {
            item.createDate = dealDate(item.createDate);
          });
          self.tableData = res.data.content;
          self.totalNum = res.data.total;
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    recognitionTestStudents(classId) {
      _recognitionTestStudents({ classSheetId: classId }).then(res => {
        if (res.code === 0) {
          console.log(res.data);
          this.students = res.data;
        }
      });
    },
    studentModelOK() {
      _recognitionExportErrorStatistics({
        classSheetIds: this.selectSubjects.map(item => item.id),
        studentId: this.selectStudent
      }).then(res => {
        if (res.code === 0) {
          window.open(global.positdownload + res.data.fileName);
        }
      });
    }
  },
  mounted() {
    this.getClassCardList();
  }
};
</script>
<style >
.ivu-table-tbody .selected_row_class td {
  background-color: #cfcece !important;
}
</style>



// WEBPACK FOOTER //
// src/components/OCRCard.vue